import React from 'react';
import Loader from '@/components/common/Loader';
import LoaderSizes from '@/constants/ui/LoaderSizes';
import translate from '@/lib/intl/translate';

type CredentialsLoaderProps = {
  integrationId: string;
};

export default function CredentialsLoader({
  integrationId = '',
}: CredentialsLoaderProps) {
  return (
    <div className="rounded-lg border border-grey-300 bg-white p-3 md:p-6">
      <div className="flex flex-col items-center p-16 text-center">
        <h3 className="mb-3 type-h2 md:mb-4">
          {translate('INTEGRATIONS_CONNECTING')}{' '}
          <span className="capitalize">{integrationId}</span>
        </h3>
        <div className="mb-4 type-body3 md:mb-8 md:type-body1">
          {translate('INTEGRATIONS_VERIFY')}
        </div>
        <Loader size={LoaderSizes.XL} />
      </div>
    </div>
  );
}
